<template>
  <div id="web">
    <mycarousel></mycarousel>
    <div class="web1">
        <p class="web1title">功能强大的网站定制功能</p>
        <ul>
            <li v-for="(item,index) in web1" :key="index" class="wow animate__animated animate__fadeInUp">
                <img :src="item.icon" alt="">
                <div>
                    <p class="title">{{item.title}}</p>
                    <p class="content">{{item.content}}</p>
                </div>
            </li>
        </ul>
    </div>

    <div class="web2">
        <div v-for="(item,index) in web2" :key="index" class="web2Box">
            <ul :class="['wow','animate__animated',index%2==0?'animate__fadeInLeft':'animate__fadeInRight']">
                <li >
                    <p class="title">{{item.title}}</p>
                    <p class="subtitle">{{item.subtitle}}</p>
                    <!-- <div>
                        <button class="button1">立即咨询</button>
                        <button class="button2">申请试用</button>
                    </div> -->
                </li>
                <li>
                    <img :src="item.icon" alt="">
                </li>
            </ul>
        </div>
    </div>

    <div class="web3">
        <p class="title">适用于上百个热门行业</p>
        <ul>
            <li v-for="(item,index) in web3" :key="index" class="wow animate__animated animate__fadeInUp">
                <img :src="item.icon" alt="">
                <p>{{item.title}}</p>
            </li>
        </ul>
        <p class="subtitle">更多热门行业等你来定制……</p>
    </div>

    <mytechnology></mytechnology>
  </div>
</template>

<script>
import mycarousel from  '@/components/carousel/carousel.vue'
import mytechnology from  '@/components/technology/technology.vue'
export default {
    name: "web",
    components: {
        mycarousel,
        mytechnology
    },
    data() {
        return {
            carouselData:[require('@/assets/home/carousel1.png'),require('@/assets/home/carousel2.png'),require('@/assets/home/carousel3.png')],
            web1:[
                {
                    icon:require('@/assets/web/web1icon1.png'),
                    title:"设计精美，风格多样",
                    content:"网站样式丰富，设计精美，免费更新界面内容和板块"
                },
                {
                    icon:require('@/assets/web/web1icon2.png'),
                    title:"快捷定制，功能轻松添加",
                    content:"所见即所得，功能内容轻松添加，定制您所看到的所有功能"
                },
                {
                    icon:require('@/assets/web/web1icon3.png'),
                    title:"功能完善，主流应用",
                    content:"功能广泛，涵盖大部分网站的主流功能，想要什么就有什么"
                },
                {
                    icon:require('@/assets/web/web1icon4.png'),
                    title:"快速定制，7天出图",
                    content:"最快15天验收，同时拥有自适应手机网站，7+7模式定制"
                },
                {
                    icon:require('@/assets/web/web1icon5.png'),
                    title:"技术强大，成本较低",
                    content:"一站式服务，完善售后服务，全程网站监控，降低建站与维护成本"
                },
                {
                    icon:require('@/assets/web/web1icon6.png'),
                    title:"操作简易流畅，性价比高",
                    content:"成本极低，速度快，设计功能精美完善，操作简易流畅，性价比高"
                }
            ],
            web2:[
                {
                    title:"企业官网定制，满足不同企业多样化需求",
                    subtitle:"针对不同行业、不同业务场景的企业提供不同的定制功能，根据不同的企业提供不同风格的界面设计与方案",
                    icon:require('@/assets/web/web2icon1.png')
                },
                {
                    title:"电商官网定制，多元化商城系统",
                    subtitle:"数十年电商商城搭建经验，品类功能齐全，满足不同行业搭建需求，帮助商家快速搭建属于自己的个性化独立电商商城",
                    icon:require('@/assets/web/web2icon2.png')
                },
                {
                    title:"品牌官网定制，定制属于你的国际品牌",
                    subtitle:"为您的品牌推广和企业文化推广奠定良好的基础，为您走向世界和国际化做好充足的准备，为品牌形象做最好的推广",
                    icon:require('@/assets/web/web2icon3.png')
                },
                {
                    title:"响应式网站定制，多端实时适应",
                    subtitle:"响应式布局，一站式服务，同时满足多端口展示，成本低，速度快，设计功能精美完善，操作简易流畅，性价比高",
                    icon:require('@/assets/web/web2icon4.png')
                },
                {
                    title:"营销型网站定制，主营业务全盘托出",
                    subtitle:"为您的企业和产品量身定制风格相符的营销型网站，助力网站推广全网营销，助力SEO优化推广，让更多人了解您的企业",
                    icon:require('@/assets/web/web2icon5.png')
                },
                {
                    title:"外贸网站定制，全球化品牌定制",
                    subtitle:"支持英文、法语等多种语言展示，轻松开启企业品牌出海计划，打造全球品牌，快速打通全球市场",
                    icon:require('@/assets/web/web2icon6.png')
                }
            ],
            web3:[
                {
                    icon:require('@/assets/web/web3icon1.png'),
                    title:"酒店宾馆"
                },
                {
                    icon:require('@/assets/web/web3icon2.png'),
                    title:"婚纱摄影"
                },
                {
                    icon:require('@/assets/web/web3icon3.png'),
                    title:"汽车美容"
                },
                {
                    icon:require('@/assets/web/web3icon4.png'),
                    title:"教育教研"
                },
                {
                    icon:require('@/assets/web/web3icon5.png'),
                    title:"房产地产"
                },
                {
                    icon:require('@/assets/web/web3icon6.png'),
                    title:"旅游行业"
                },
                {
                    icon:require('@/assets/web/web3icon7.png'),
                    title:"金融行业"
                },
                {
                    icon:require('@/assets/web/web3icon8.png'),
                    title:"保险行业"
                },
                {
                    icon:require('@/assets/web/web3icon9.png'),
                    title:"家装行业"
                },
                {
                    icon:require('@/assets/web/web3icon10.png'),
                    title:"医疗美容"
                },
                {
                    icon:require('@/assets/web/web3icon11.png'),
                    title:"物业管理"
                },
                {
                    icon:require('@/assets/web/web3icon12.png'),
                    title:"工商工业"
                },
            ],
            web4:[require('@/assets/web/web4icon1.png'),require('@/assets/web/web4icon2.png'),require('@/assets/web/web4icon3.png'),require('@/assets/web/web4icon4.png')]
        }
    },
    mounted(){
        //初始化动画
        this.$nextTick(()=>{
            this.$wow.init()
        })
    }
}
</script>

<style lang="scss">
  :root {
    --web-max-width: 1920px;
    --web-min-width: 1300px;
  }
  #web{
    .web1{
        min-width:var(--web-min-width);
        // max-width:var(--web-max-width);
        margin:0 auto 65px;
        .web1title{
            font-size: 26px;
            font-weight: 400;
            color: #333333;
            text-align: center;
            padding: 60px 0 40px;
        }
        ul{
            width: 1200px;
            height: 350px;
            background: #FFFFFF;
            box-shadow: 0px 2px 18px 1px rgba(217,223,231,0.6);
            border-radius: 8px 8px 8px 8px;
            margin:0 auto;
            display: flex;
            flex-wrap: wrap;
            padding: 60px 44px;
            li{
                width: 294px;
                display: flex;
                img{
                    width: 50px;
                    height: 50px;
                    margin-right: 20px;
                }
                .title{
                    font-size: 20px;
                    font-weight: 400;
                    color: #333333;
                    margin-bottom: 6px;
                }
                .content{
                    font-size: 14px;
                    font-weight: 400;
                    color: #666666;
                }
            }
            li:nth-child(2),li:nth-child(5){
                margin: 0 114px;
            }
            li:nth-child(-n+3){
                margin-bottom: 80px;
            }
        }
    }

    .web2{
        min-width:var(--web-min-width);
        // max-width:var(--web-max-width);
        margin:0 auto;
        .web2Box{
            ul{
                width: 1200px;
                margin:0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                img{
                    height: 450px;
                }
                .title{
                    font-size: 28px;
                    font-weight: 400;
                    color: #333333;
                    margin-bottom: 16px;
                }
                .subtitle{
                    font-size: 16px;
                    font-weight: 400;
                    color: #666666;
                    margin-bottom: 48px;
                    width: 502px;
                }
                .button1{
                    width: 106px;
                    height: 40px;
                    background: #0071EF;
                    border-radius: 4px 4px 4px 4px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #FFFFFF;
                    margin-right: 20px;
                    cursor: pointer;
                }
                .button2{
                    width: 106px;
                    height: 40px;
                    background: #DCE9F9;
                    border-radius: 4px 4px 4px 4px;
                    opacity: 1;
                    font-size: 16px;
                    font-weight: 400;
                    color: #0071EF;
                    cursor: pointer;
                }
            }
        }
        .web2Box:nth-child(2n-1){
            background-color: #F8F9FC;;
        }
        .web2Box:nth-child(2n) ul{
            flex-direction: row-reverse;
        }
    }
    .web3{
        min-width:var(--web-min-width);
        // max-width:var(--web-max-width);
        margin:0 auto;
        padding: 60px 0 86px;
        background: linear-gradient(93deg, #F0F3FA 0%, #F8F9FC 100%);
        .title{
            font-size: 34px;
            font-weight: 400;
            color: #333333;
            text-align: center;
            margin-bottom: 60px;
        }
        .subtitle{
            font-size: 24px;
            font-weight: 400;
            color: #666666;
            text-align: center;
        }
        ul{
            width: 1120px;
            margin:0 auto;
            display: flex;
            flex-wrap: wrap;
            text-align: center;
            li{
                margin-bottom: 60px;
            }
            p{
                font-size: 20px;
                font-weight: 400;
                color: #333333;
            }
            img{
                width: 100px;
            }
            li:nth-child(-n+5),li:nth-child(n+7):nth-child(-n+11){
                margin-right: 104px;
            }

        }
    }
    
  }
</style>